<template lang="html">
    <div :is="'reservation-payment'" :direction="1" ></div>
</template>

<script>
import ReservationPayment from './ReservationPayment'
export default {
    components:{
        ReservationPayment
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// ReservationPayOut.vue?3812d3e6